var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sort_icon"},[_c('SjIcon',{attrs:{"size":20,"iconSize":14,"imgSrc":_vm.imgSrc,"stopEvent":false}}),(_vm.priority)?_c('span',{staticClass:"order_number"},[_vm._v(" "+_vm._s(_vm.priority)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }